import type { Metadata } from "@/lib/head";

import CustomerScreenShell from "@/components/customer-screen-shell";
import { DEMO_LINK_EXPIRES_AT, DEMO_QUOTE } from "@buildpy/core/modules/demo/data";
import { DEMO_PATH, DEMO_TOKEN } from "@buildpy/core/modules/demo/routes";
import A4Fit from "@/modules/print/a4-fit";
import PrintButton from "@/modules/print/print-button";
import QuoteDocument from "@/modules/print/quote-document";
import { formatDate } from "@/modules/quote/ui/format";
import CustomerHeadOrg from "@/modules/share/ui/customer-head-org";
import { QuoteMobileSummary, QuoteMobileTrade, sortedTrades, tradeIndexOf } from "@/modules/share/ui/quote-mobile";

export const metadata: Metadata = {
  title: "견적서 데모",
  robots: { index: false, follow: true },
};

interface Props {
  searchParams?: { [key: string]: string | string[] | undefined };
}

// 고객 견적서(/s/[token]) 데모 — 같은 컴포넌트로 폰은 요약·공종 상세, md 이상은 A4 문서를 그린다.
const Page = ({ searchParams }: Props) => {
  const data = DEMO_QUOTE;
  const tradeNo = tradeIndexOf(searchParams?.t, sortedTrades(data).length);

  return (
    <CustomerScreenShell className="p-0">
      <div className="print-hide md:hidden" data-testid="quote-mobile">
        {tradeNo ? (
          <QuoteMobileTrade basePath={DEMO_PATH.quote} data={data} n={tradeNo} token={DEMO_TOKEN} />
        ) : (
          <QuoteMobileSummary basePath={DEMO_PATH.quote} data={data} expiresAt={DEMO_LINK_EXPIRES_AT} token={DEMO_TOKEN} />
        )}
      </div>

      <div className="hidden md:block print:block" data-testid="quote-document-view">
        <header className="print-hide sticky top-(--safe-top) z-10 flex flex-wrap items-center justify-between gap-2 border-b border-border bg-card px-4 py-2.5">
          <CustomerHeadOrg name={data.org.name} tel={data.org.tel} />
          <PrintButton label="PDF 저장(인쇄)" variant="outline" />
        </header>

        <div className="print-root px-2 py-4 md:px-4">
          <A4Fit>
            <QuoteDocument data={data} />
          </A4Fit>
        </div>

        <footer className="print-hide px-4 pb-8 pt-2 text-center text-xs text-muted-foreground">
          링크 유효기간 {formatDate(DEMO_LINK_EXPIRES_AT)}까지 · 문의 {data.org.name}
        </footer>
      </div>
    </CustomerScreenShell>
  );
};

export default Page;
